import React, { Fragment, ReactNode, Suspense, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { Navbar } from './sub/Navbar';

import { closeAllModals } from '../store/modal.slice';

import { ConfirmationModal } from './modals/Confirmation';
import { ManageSubClientModal } from './modals/ManageSubClient';
import { ManageSubClientUsersModal } from './modals/ManageSubClientUsers';
import { ManageCohortModal } from './modals/ManageCohort';
import { ManageCohortMembersModal } from './modals/ManageCohortMembers';
import { ManageEmployeeModal } from './modals/ManageEmployee';

interface AppProps {
    children: ReactNode;
};
export const App = (props: AppProps) => {
    const { children } = props;

    const location = useLocation();
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        dispatch(closeAllModals());
        // eslint-disable-next-line
    }, [location]);

    return (
        <Suspense fallback={<div />}>
            <ConfirmationModal />
            <ManageSubClientModal />
            <ManageSubClientUsersModal />
            <ManageCohortModal />
            <ManageCohortMembersModal />
            <ManageEmployeeModal />

            <div className="app">
                {!location.pathname.includes('/auth') && (
                    <Fragment>
                        <Navbar />
                        <br /><br /><br />
                    </Fragment>
                )}
                {children}
            </div>

            <Toaster />
        </Suspense>
    );
};